"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.historicalReportPlaceholderTranslations = {
    "en": {
        selectAnAgent: "Select an agent and date range above to view activity.",
    },
    "de": {
        selectAnAgent: "Wählen Sie oben einen Mitarbeiter und einen Zeitraum aus, um die Aktivität anzuzeigen.",
    },
    "nl": {
        selectAnAgent: "Kies een agent en datumbereik hierboven om activiteit te zien.",
    },
    "it": {
        selectAnAgent: "Seleziona qui sopra un agente e un periodo per visualizzare le attività.",
    },
    "fr": {
        selectAnAgent: "Sélectionner un agent et une plage de dates ci-dessus pour afficher l'activité.",
    },
    "es": {
        selectAnAgent: "Seleccione un agente y un intervalo de fechas arriba para ver la actividad.  ",
    },
    "ja": {
        selectAnAgent: "上部でエージェントとデータ範囲を選択し、活動を確認する",
    },
    "en-GB": {
        selectAnAgent: "Select an agent and date range above to view activity.",
    },
    "ru": {
        selectAnAgent: "Выберете агента и промежуток времени для того, чтобы посмотреть его активность.",
    },
};
